import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { LoadingReducerState, LoadingReducerStateKeys } from "./reducer_interface";

// Loading the config
// import config from "envConfig";

const ConfigurationLoaders = {
  isOnboardCityListInProgress: false,
  isOnboardWareHouseListInProgress: false,
  isOnboardEquipmentListInProgress: false,
  isOnboardServicesListInProgress: false,
  isOnboardStaffListInProgress: false,
  isOnboardStaffCategoryListInProgress: false,
  isRolesAndPermissionListInProgress: false,
};
const CouponServiceLoader = {
  isCouponServiceListInProgress: false,
  isCouponServiceDetailsInProgress: false,
};

const MembershipSetupLoader = {
  isMembershipSetupListInProgress: false,
  isMembershipExtensionListInProgress: false,
  isMedicalHistoryListInprogress: false,
};
const QuickCommerceLoaders = {
  isOnboardPincodeListInProgress: false,
};

const EMRLoaders = {
  isEMRFetchInProgress: false,
  isEMRDetailsFetchInProgress: false,
  isEMRLocalSaveInProgress: false,
  isEMRCreateInProgress: false,
  isEMRUpdateInProgress: false,
  isEMRImageUploadInProgress: false,
  isEMRDownloadViewInProgress: false,
  isEMRServerSaveInProgress: false,
  isVoiceEMRInProgress: false,
};

const GeoLocationLoaders = {
  isGeoLocationSearchInProgress: false,
};

const CustomerLoaders = {
  isMobileNumberValidationInProgress: false,
  isCustomerUpdateInProgress: false,
  isCustomerCreationInProgress: false,
  isCustomerBookingsFetchInProgress: false,
  isCustomerSearchInProgress: false,
  isCustomerDetailsFetchInProgress: false,
  isCustomerProfileFetchInProgress: false,
  isPetCreationInProgress: false,
  isInvoiceInProgress: false,
  isClosingDataInProgress: false,
  isCollectAmountDataInProgress: false,
  isRaiseListInProgress: false,
  isSendOTPInProgress: false,
  isOTPVerificationInProgress: false,
  isCustomerDetailsSyncInProgress: false,
};

const BookingLoaders = {
  isOverBookingPermissionListInProgress: false,
  isBookingCreationInProgress: false,
  isShiftAppointmentInProgress: false,
};

const AuthLoaders = {
  isUserRoleInProgress: false,
};

const PetLoaders = {
  isPetListFetchInProgress: false,
  isCustomerPetCreationInProgress: false,
  isCustomerPetDeletInProgress: false,
  isCustomerPetDetailsFetchInProgress: false,
  isCustomerPetUpdationInProgress: false,
};

const OrgLoaders = {
  isOrgCitiesInProgress: false,
  isOrgServicesInProgress: false,
  isOrgServicesForBookingInProgress: false,
  isOrgClinicProvidersInProgress: false,
  isOrgBookingStatusesInProgress: false,
  isSendAppRequestInProgress: false,
  isVmsCategoryInProgress: false,
  isVmsSubCategoryInProgress: false,
};

const StaticLoaders = {
  isStaticAPIInProgress: false,
  isPetMoodInProgress: false,
  isPetGendersInProgress: false,
  isDogBreedsInProgress: false,
  isCatBreedsInProgress: false,
  isAddressLabelsInProgress: false,
  isPetStatusesInProgress: false,
  isPetSpeciesInProgress: false,
  ...OrgLoaders,
};

const SlotsLoaders = {
  isAvailableSlotsInProgress: false,
  isBookedSlotsInProgress: false,
  isOverbookingSlotsInProgress: false,
  isLateBookingStatusCheckInProgress: false,
  isOverbookingAllowedInProgress: false,
};

const PWLLoaders = {
  isPWLInProgress: false,
  isPWLStatsFetchInProgress: false,
  isAtHomeServicesListingInProgress: false,
  isAtHomeServicesStatsInProgress: false,
};

const ROTALoaders = {
  isClinicWiseRotaListInProgress: false,
  isRotaShiftListInProgress: false,
  isOverbookingEligibleServicesInProgress: false,
  isOverbookingRequestsInProgress: false,
  isOverbookingRequestMutationInProgress: false,
  isOverbookingBulkUploadInProgress: false,
};
const OrdersLoaders = {
  isQcOrderListLoadingInProgress: false,
  isQctransferOrderLoadingInProgress: false,
  isQcOrderStatsLoadingInProgress: false,
};
const StaffCalendarLoaders = {
  isStaffCalendarLoadingInProgress: false,
  isStaffCalendarBookingDetailsLoadingInProgress: false,
};
const InventoryLoaders = {
  isBatchingListLoadingInProgress: false,
  isPOCreateInProgress: false,
  isTaxListLoadingInProgress: false,
  isManufacturereListLoadingInProgress: false,
  isInventoryVendorListLoadingInProgess: false,
  isInventoryProductListLoadingInProgess: false,
  isServiceListLoadingInProgess: false,
  isInventoryServiceListLoadingInProgess: false,
  isBOMSetupListLoadingInProgress: false,
  isInventoryPurchaseOrderListLoadingInProgess: false,
  isInventoryGrnDetailInProgress: false,
  isInventoryProductMoveGoodToBadInProgress: false,
  isInventoryProductGoodInventory: false,
  isInventoryProductBadInventoryRequest: false,
  isInventorySnapShotLoader: false,
  isInventoryCompletedGRNListInProgress: false,
  isvaccinationTableLoading: false,
  isReminderTableLoading: false,
  isvaccinationSingleDataLoading: false,
  isPOStatusUpdateInProgress: false,
  isBulkUploadInProgress: false,
  isCreatePOFromSheetInProgress: false,
};
const ServiceDeskLoader = {
  isServiceDeskTicketList: false,
};

const CartLoaders = {
  isNewCartInProgress: false,
  isCustomerCartsListInProgress: false,
  isStockInCompleteInProgress: false,
  isCustomerCartTableInProgress: false,
  isCustomerHDCartTableInProgress: false,
  isCustomerCartMirrorTableInProgress: false,
  isCustomerInvoiceTableInProgress: false,
  isCustomerRemindersTableInProgress: false,
  isCustomerCartListTableInProgress: false,
  isCustomerSnapmintAmountCancelInProgress: false,
  isCustomerCartItemsSearchInProgress: false,
  isCustomerEmrSearchInProgress: false,
  isCustomerTransactionTableInProgress: false,
  isCustomerWalletTableInProgress: false,
  isCustomerCreditNoteTableInProgress: false,
  isCustomerDebitNoteTableInProgress: false,
  isFinanceSummaryLoading: false,
  isCustomerRefundRequestTableInProgress: false,
  isCustomerWalletDetailsInProgress: false,
  isNudgeLoadingInpogress: false,
};
const LabPartnerLoaders = {
  isLabPartnerListInProgress: false,
};

// Define the initial state using that type
const intialRootState: LoadingReducerState = {
  ...EMRLoaders,
  ...CustomerLoaders,
  ...PetLoaders,
  ...StaticLoaders,
  ...AuthLoaders,
  ...PWLLoaders,
  ...GeoLocationLoaders,
  ...BookingLoaders,
  ...SlotsLoaders,
  ...ConfigurationLoaders,
  ...CouponServiceLoader,
  ...MembershipSetupLoader,
  ...QuickCommerceLoaders,
  ...ROTALoaders,
  ...OrdersLoaders,
  ...StaffCalendarLoaders,
  ...InventoryLoaders,
  ...ServiceDeskLoader,
  ...CartLoaders,
  ...LabPartnerLoaders,
};

export const rootStateSlice = createSlice({
  name: "loadingState",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: intialRootState,
  reducers: {
    setLoading: (state, action: PayloadAction<{ key: LoadingReducerStateKeys; status: boolean }>) => {
      state[action.payload.key as LoadingReducerStateKeys] = action.payload.status;
    },
  },
});

export const { setLoading } = rootStateSlice.actions;

export default rootStateSlice.reducer;
